module.exports = __webpack_public_path__ + "img/image_024.96c4e093.jpg";